module.exports = __webpack_public_path__ + "img/yellow-pin.5d761574.png";